export const width=934;export const height=305;export default{width:width,height:height};